import React, { CSSProperties, FC } from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import { Container, useScreenClass } from 'react-grid-system'
import { Button, ImageBlock, SectionTitle } from '../shared'
import { IGLASS, OEISENBERG, ALEC, VWILLIAMS, JDELORE, RONALDYOUNGJR } from '../../assets/guests'

const imgStyles: CSSProperties = {
  height: '300px',
}

const Guests: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  return (
    <section>
      <SectionTitle color="black">Guests</SectionTitle>
      <Container style={{ margin: '3rem auto 5rem' }}>
        <style>{`
          /* Push indicators below the slide content and add bottom padding to slides */
          .guest-carousel .control-dots { bottom: -28px; }
          .guest-carousel .slide { padding-bottom: 2.5rem; }
        `}</style>
        <div style={{ marginBottom: '3.5rem' }}>
          <Carousel
            showArrows
            autoPlay
            infiniteLoop={false}
            stopOnHover={false}
            swipeable
            dynamicHeight={false}
            showThumbs={false}
            showStatus={false}
            interval={5000}
            centerMode={isDesktop}
            centerSlidePercentage={isDesktop ? 33.33 : 100}
            className="guest-carousel"
            aria-label="Featured guests carousel"
            renderArrowPrev={(onClickHandler, hasPrev, label) =>
              hasPrev && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  aria-label={label}
                  style={{
                    position: 'absolute',
                    zIndex: 2,
                    top: 'calc(50% - 20px)',
                    left: 15,
                    background: 'rgba(0, 0, 0, 0.5)',
                    border: 'none',
                    color: 'white',
                    fontSize: '2rem',
                    cursor: 'pointer',
                  }}
                >
                  ‹
                </button>
              )
            }
            renderArrowNext={(onClickHandler, hasNext, label) =>
              hasNext && (
                <button
                  type="button"
                  onClick={onClickHandler}
                  aria-label={label}
                  style={{
                    position: 'absolute',
                    zIndex: 2,
                    top: 'calc(50% - 20px)',
                    right: 15,
                    background: 'rgba(0, 0, 0, 0.5)',
                    border: 'none',
                    color: 'white',
                    fontSize: '2rem',
                    cursor: 'pointer',
                  }}
                >
                  ›
                </button>
              )
            }
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              const style = {
                margin: '0 6px',
                cursor: 'pointer',
                color: isSelected ? 'black' : '#c0c0c0',
                fontSize: '1.2rem',
                display: 'inline-block',
              } as React.CSSProperties
              return (
                <span
                  style={style}
                  onClick={onClickHandler}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClickHandler(e as unknown as React.MouseEvent) } }}
                  data-index={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  aria-label={`Go to slide ${index + 1}${isSelected ? ' (current)' : ''}`}
                  aria-pressed={isSelected}
                >
                  ●
                </span>
              )
            }}
          >
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={IGLASS}
                alt="Ira Glass portrait"
                title="Ira Glass"
                para="Host and Producer of This American Life"
                color="black"
                imgStyles={imgStyles}
              />
            </div>
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={OEISENBERG}
                alt="Ophira Eisenberg portrait"
                title="Ophira Eisenberg"
                para="Host of Ask Me Another"
                color="black"
                imgStyles={imgStyles}
              />
            </div>
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={ALEC}
                alt="Alec portrait"
                title="Alec Baldwin"
                para="Host of Here's The Thing"
                color="black"
                imgStyles={imgStyles}
              />
            </div>
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={VWILLIAMS}
                alt="Veralyn Williams portrait"
                title="Veralyn Williams"
                para="EP, The United States of Anxiety (WNYC)"
                color="black"
                imgStyles={imgStyles}
              />
            </div>
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={RONALDYOUNGJR}
                alt="Ronald Young Jr. portrait"
                title="Ronald Young Jr."
                para='Creator and Host of "Weight for It"'
                color="black"
                imgStyles={imgStyles}
              />
            </div>
            <div style={{ padding: '0 1rem' }}>
              <ImageBlock
                src={JDELORE}
                alt="John Delore portrait"
                title="John Delore"
                para="Senior Editor, Stitcher"
                color="black"
                imgStyles={imgStyles}
              />
            </div>
          </Carousel>
        </div>
        <div style={{ textAlign: 'center', marginTop: '-1.5rem' }}>
          <Button variant="red" path="/guests">
            More Guests
          </Button>
        </div>
      </Container>
    </section>
  )
}

export default Guests